import React from 'react';
import { motion } from 'framer-motion';
export function ProductShowcase() {
  const row1Colors = ['bg-blue-500', 'bg-green-500', 'bg-red-500', 'bg-purple-500', 'bg-gray-500', 'bg-orange-500'];
  const row2Colors = ['bg-green-700', 'bg-green-500', 'bg-orange-600', 'bg-purple-500', 'bg-gray-500', 'bg-amber-800'];
  return <section className="bg-brand-dark py-24 px-4 border-t border-brand-border pt-[10px] pb-[10px]" data-id="element-266">
      <div className="max-w-5xl mx-auto text-center" data-id="element-267">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-268">
          <div className="flex items-center justify-center gap-2 text-brand-accent font-badge font-bold tracking-widest text-sm uppercase mb-4" data-id="element-269">
            <span className="text-xl" data-id="element-270">🔬</span> PROFEPACK
          </div>

          <h2 className="text-3xl md:text-5xl font-heading font-bold mb-8 uppercase text-[#00FF84]" data-id="element-271">
            Megapack Física y Química Lista
          </h2>

          <div className="mb-12 flex flex-col gap-2" data-id="element-272">
            <p className="text-xl md:text-2xl text-white font-bold" data-id="element-273">
              12 tomos organizados por año y materia.
            </p>
            <p className="text-base md:text-lg text-white/70 max-w-3xl mx-auto font-medium leading-relaxed" data-id="element-274">
              240 clases con guion completo. 6 bonos estratégicos. Todo listo
              para usar desde hoy.
            </p>
          </div>
        </motion.div>

        {/* Grid Showcase */}
        <motion.div className="relative max-w-3xl mx-auto mb-16" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-275">
          <div className="grid grid-cols-6 gap-2 md:gap-3 mb-6" data-id="element-276">
            {/* Row 1 */}
            {row1Colors.map((color, i) => <div key={`r1-${i}`} className={`${color} border-2 border-[#FFCC00] rounded-lg md:rounded-xl aspect-[3/4] flex items-end justify-center pb-2 md:pb-4 shadow-lg`} data-id="element-277">
                <span className="text-white font-bold text-sm md:text-xl" data-id="element-278">
                  {i + 1}°
                </span>
              </div>)}
            {/* Row 2 */}
            {row2Colors.map((color, i) => <div key={`r2-${i}`} className={`${color} border-2 border-[#FFCC00] rounded-lg md:rounded-xl aspect-[3/4] flex items-end justify-center pb-2 md:pb-4 shadow-lg`} data-id="element-279">
                <span className="text-white font-bold text-sm md:text-xl" data-id="element-280">
                  {i + 1}°
                </span>
              </div>)}
          </div>

          {/* Overlapping Badge */}
          <div className="absolute -bottom-5 left-1/2 -translate-x-1/2 bg-brand-card border-2 border-[#FFCC00] text-[#FFCC00] px-6 py-2 rounded-full font-bold text-sm md:text-base whitespace-nowrap shadow-xl z-10" data-id="element-281">
            12 TOMOS COMPLETOS
          </div>
        </motion.div>

        {/* Feature Badges */}
        <motion.div className="flex flex-wrap justify-center gap-3 md:gap-4 max-w-2xl mx-auto mt-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-282">
          {['✅ Por grado/año', '✅ Con guion', '✅ Con evaluación', '✅ Con bonos'].map((item, i) => <div key={i} className="bg-brand-card border border-[#FFCC00] px-5 py-2.5 rounded-full flex items-center gap-2 shadow-sm" data-id="element-283">
              <span className="font-medium text-white/90 text-sm md:text-base" data-id="element-284">
                {item}
              </span>
            </div>)}
        </motion.div>
      </div>
    </section>;
}